export const FIELDS = {

  ID: 'id',
  PAYMENT_ID: 'paymentId',
  INVOICE_ID: 'invoiceId',
  BALANCE: 'balance',
  PAYMENT_AMOUNT: 'paymentAmount',
  CREDIT_AMOUNT: 'creditAmount',
  AMOUNT: 'amount',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  REFERENCE_NUMBER: 'referenceNumber',
  PAYMENT_DATE: 'paymentDate',
  PAYMENT_METHOD_NAME: 'paymentMethodName',
  TOTAL: 'total',
  COMMENTS: 'comments',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};